// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4930cd3e","788":"5d7048ba"}[chunkId] + ".chunk.js";
};